<template>
    <div class="createOrganization">
        <div class="designBasic mb-4">
            <div class="createDiv">
                <img src="../../../assets/images/title-icon.png" alt="">
                <h3>Create Organizations</h3>
            </div>
        </div>
        <div>
            <div class="dataFill">
                <form>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="col">
                                <div class="firstOrga mb-4">
                                    <label class="cssLabelOrganization">Organization Name<span style="color: #E95626">*</span></label>
                                    <input type="text" id="organization_name" class="form-control"
                                        v-model="organization.name" placeholder="Organization Name"
                                        @input="[changeHandler($event, errors, 'name') , setData($event,'name')]">
                                    <div v-if="errors['name'].length > 0">
                                        <div v-for="msg in errors['name']" class="err text-danger position-absolute">{{msg}}
                                        </div>
                                    </div>
                                </div>
                                <div class="fourthOrga">
                                    <label class="cssLabelOrganization">Mail Domain<span style="color: #E95626">*</span></label>
                                    <input type="email" id="type" class="form-control" v-model="organization.type" placeholder="Mail Domain"
                                        @input="[changeHandler($event, errors, 'domain') , setData($event,'domain')]">
                                    <div v-if="errors['domain'].length > 0">
                                        <div v-for="msg in errors['domain']" class="err text-danger position-absolute" style="width: 40%">{{msg}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="col">
                                <div class="thirdOrga mb-4">
                                    <label class="cssLabelOrganization">Organization URL<span style="color: #E95626">*</span></label>
                                    <input type="text" id="organization_url" class="form-control" v-model="organization.url"
                                        placeholder="Organization URL"
                                        @input="[changeHandler($event, errors, 'host') , setData($event,'host')]">
                                    <div v-if="errors['host'].length > 0">
                                        <div v-for="msg in errors['host']" class="err text-danger position-absolute">{{msg}}
                                        </div>
                                    </div>
                                </div>
                                <div class="secOrga mb-4">
                                    <label class="cssLabelOrganization">Admin Email<span style="color: #E95626">*</span></label>
                                    <input type="email" id="admin_email" class="form-control"
                                        v-model="organization.user_email" placeholder="Admin Email"
                                        @input="[changeHandler($event, errors, 'user_email') , setData($event,'user_email')]">
                                    <div v-if="errors['user_email'].length > 0">
                                        <div v-for="msg in errors['user_email']" class="err text-danger position-relative">
                                            {{msg}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                                    <div class="row">
                        <div class="col-md-6">
                            <div class="col">
                                <div class="firstOrga mb-4">
                                    <label class="cssLabelOrganization">User Count<span style="color: #E95626">*</span></label>
                                    <input type="number" id="max_number_of_users" class="form-control"
                                        v-model="organization.max_number_of_users" placeholder="User Count"
                                        @input="[changeHandler($event, errors, 'max_number_of_users') , setData($event,'max_number_of_users')]">
                                    <div v-if="errors['max_number_of_users'].length > 0">
                                        <div v-for="msg in errors['max_number_of_users']" class="err text-danger position-absolute">{{msg}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="col">
                                <div class="thirdOrga mb-4">
                                    <label class="cssLabelOrganization">Total file size (MB)<span style="color: #E95626">*</span></label>
                                    <input type="number" id="organization_url" class="form-control" v-model="organization.total_file_size"
                                        placeholder="Total file size"
                                        @input="[changeHandler($event, errors, 'total_file_size') , setData($event,'total_file_size')]">
                                    <div v-if="errors['total_file_size'].length > 0">
                                        <div v-for="msg in errors['total_file_size']" class="err text-danger position-absolute">{{msg}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div v-if="errorMessages.length > 0" class="error-container">
                    <div v-for="msg in errorMessages" class="text-danger my-4">{{msg}}</div>
                </div>
            </div>
            <AlartModal  v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
        </div>
        <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                        @close-modal="confirmModalHandler($event)"/>
        
        <div class="buttonSave">
            <router-link class="back-route" @click="backHandler" :to="this.isDataFlag ? '#':'/organizations'">
                        <button class="back-btn">Back</button>
            </router-link>
            &nbsp;
            <button @click.prevent="SaveOrganization">Save</button>
        </div>
    </div>
</template>

<script>
    import organization from "../../../api-services/organization";
    import AlartModal from "../../components/AlartModal";
    import changeHandler from '../../../validation/organizationValidation';
    import ConfirmationModal from '../../components/ConfirmationModal';
    import {computed} from "vue";

    export default {
        name: 'create-organization',
        data() {
            return {
                changeHandler,
                organization: {
                    name: null,
                    url: null,
                    user_email: null,
                    type: null,
                    max_number_of_users: null,
                    total_file_size:null
                },
                errors: {
                    name: [],
                    user_email: [],
                    host: [],
                    domain:[],
                    max_number_of_users:[],
                    total_file_size:[],
                    isError: false
                },
                ImagePath: '',
                showModal: false,
                message: null,
                errorMessages: [],
                responseErrorMessage: '',
                showErrorModal: false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData: {
                    name: false,
                    user_email: false,
                    host: false,
                    domain:null,
                    max_number_of_users: false,
                    total_file_size: false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        methods: {
            async backHandler() {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if (setDataFlag) {
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                } else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'name') {
                    if (val !== null) {
                        this.isData.name = true;
                    } else {
                        this.isData.name = false;
                    }
                }

                if (type === 'user_email') {
                    if (val !== null) {
                        this.isData.user_email = true;
                    } else {
                        this.isData.user_email = false;
                    }
                }

                if (type === 'host') {
                    if (val !== null) {
                        this.isData.host = true;
                    } else {
                        this.isData.host = false;
                    }
                }

                if (type === 'type') {
                    if (val !== null) {
                        this.isData.type = true;
                    } else {
                        this.isData.type = false;
                    }
                }
                if (this.isData.name || this.isData.user_email || this.isData.host || this.isData.type) {
                    this.$store.dispatch('setDataFlag', true);
                } else {
                    this.$store.dispatch('setDataFlag', false);
                }

            },
            async confirmModalHandler(event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if (event) {
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/organizations');
                }
            },
            SaveOrganization: async function () {
                try {
                    if (this.organization.name == null || this.organization.url == null || this.organization.user_email == null || this.organization.type == null) {
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'Please fill data correctly';

                        if (this.organization.name === null) {
                            this.errors.isError = true;
                            this.errors['name'][0] = '*Required';
                        }
                        if (this.organization.user_email === null) {
                            this.errors.isError = true;
                            this.errors['user_email'][0] = '*Required';
                        }
                        if (this.organization.url === null) {
                            this.errors.isError = true;
                            this.errors['host'][0] = '*Required';
                        }
                        if (this.organization.type === null) {
                            this.errors.isError = true;
                            this.errors['domain'][0] = '*Required';
                        }
                        if (this.organization.max_number_of_users === null) {
                            this.errors.isError = true;
                            this.errors['max_number_of_users'][0] = '*Required';
                        }
                        if (this.organization.total_file_size === null) {
                            this.errors.isError = true;
                            this.errors['total_file_size'][0] = '*Required';
                        }
                    } else {
                        if (!this.errors.isError) {
                            const response = await organization.create({
                                name: this.organization.name,
                                host: this.organization.url,
                                user_email: this.organization.user_email,
                                domain: this.organization.type,
                                max_number_of_users: this.organization.max_number_of_users,
                                total_file_size: this.organization.total_file_size
                            });

                            if (response.status === 201) {
                                this.showModal = true;
                                this.ImagePath = 'okImage.svg';
                                this.message = response.data.message;
                                this.organization.name = '';
                                this.organization.url = '';
                                this.organization.user_email = '';
                                this.organization.type = '';
                                this.organization.max_number_of_users = '';
                                this.organization.total_file_size = '';
                                this.errors.name = [];
                                this.errors.host = [];
                                this.errors.user_email = [];
                                this.errors.max_number_of_users = [];
                                this.errors.total_file_size = [];
                                await this.$store.dispatch('setDataFlag', false);
                                setTimeout(() => {
                                    this.$router.push({name: 'organization'});
                                }, 1000);
                            } else {
                                if (process.env.NODE_ENV === 'development')
                                    console.log('Something Wrong !');
                            }
                        }
                    }
                } catch (e) {
                    console.log({e})
                    if (e.response.data.errors) {
                        if (e.response.data.errors.name || e.response.data.errors.user_email || e.response.data.errors.host || e.response.data.errors.type
                         || e.response.data.errors.max_number_of_users || e.response.data.errors.total_file_size) {
                            if (e.response.data.errors.name)
                                e.response.data.errors.name.forEach((err, idx) => {
                                    this.errors['name'][idx] = `*${err}`
                                });
                            if (e.response.data.errors.user_email)
                                e.response.data.errors.user_email.forEach((err, idx) => {
                                    this.errors['user_email'][idx] = `*${err}`
                                });
                            if (e.response.data.errors.host)
                                e.response.data.errors.host.forEach((err, idx) => {
                                    this.errors['host'][idx] = `*${err}`
                                });
                            if (e.response.data.errors.domain)
                                e.response.data.errors.domain.forEach((err, idx) => {
                                    this.errors['domain'][idx] = `*${err}`
                                });
                            if (e.response.data.errors.max_number_of_users)
                                e.response.data.errors.max_number_of_users.forEach((err, idx) => {
                                    this.errors['max_number_of_users'][idx] = `*${err}`
                                });
                            if (e.response.data.errors.total_file_size)
                                e.response.data.errors.total_file_size.forEach((err, idx) => {
                                    this.errors['total_file_size'][idx] = `*${err}`
                                });
                        } else {
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                console.log({property})
                                let record = property.split('.')[0];
                                this.errors[property][idx++] = `${e.response.data.errors[property]}` + '\n';
                            }
                        }
                    } else if (e.response.data) {
                        this.showErrorModal = true;
                        this.ImagePath = 'close.png';
                        this.responseErrorMessage = e.response.data.message;
                    }
                }
            },
        },
        components: {
            AlartModal,
            ConfirmationModal
        }
    }
</script>

<style scoped>
    label{
        font-weight: 600;
    }

    .cssLabelOrganization{
        color:var(--color-text-label);
    }

    .createOrganization {
        padding-top: 20px;
        padding-inline: 40px;
    }

    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 18px;
        margin-right: 10px;
    }
    .back-btn{
        background-color: #707070 !important;
        padding: 0px 50px;
    }
    .back-route:hover {
        color: #FFF;
    }

    .fourthOrga input,
    .firstOrga input,
    .secOrga input,
    #organization_url {
        background-color: var(--input-background);
        color: var(--input-color);
    }
    .fourthOrga input::placeholder,
    .firstOrga input::placeholder,
    .secOrga input::placeholder,
    #organization_url::placeholder {
        color:var(--input-placeholder-color) !important;
        font-weight: normal;
        font-size: 14px;
        font-style: italic;
        opacity:1 !important;
    }
    .form-control{
        border: none;
        font-weight: normal;
    }


    .designBasic {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .designBasic .createDiv {
        display: flex;
        flex-direction: row;
    }
    .createDiv{
        align-items: center;
        justify-content: center;
    }
    .createDiv img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .createDiv h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom:0;
        font-size: calc(1rem+0.5vw);
    }

    .designBasic .createDiv button {
        border: none;
        color: #fff;
        background-color: transparent;
    }
    .buttonSave{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width:100%;
        height: 35px;
    }
    .buttonSave button {
        border: none;
        color: #fff;
        background-color: var(--btn-bg-color);
        padding: 0px 50px;
        height: 100% !important;
        border-radius: 5px;
        font-weight: normal;
        font-size: 18px;
    }

    .dataFill {
        border: 1px solid var(--table-color-data);
        background-color: var(--table-color-data);
        padding: 23px;
        border-radius: 15px;
        height: auto;
    }
</style>